import React from 'react';
import {
	Loader,
	BaasicTable,
	TableFilter,
	BaasicConfirmModal,
	BaasicHeader,
	BaasicTableExport,
	BaasicCheckbox,
} from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { ButtonGroup, Button } from '@progress/kendo-react-buttons';
import { OrderLinesExpandList, FulfillmentOrdersExpandList } from 'modules/order/pages';
import { OrderDateRangeFilter } from 'modules/order/pages';
import { fileNames } from 'common/constants';
import ReactTooltip from 'react-tooltip';

const ButtonGroupContainer = props => {
	const { t, showOrderLines, toggle } = props;
	return (
		<ButtonGroup className="k-button-group--primary">
			<Button className="btn btn--sml" togglable={true} selected={showOrderLines} onClick={() => toggle(true)}>
				{t('MARKETPLACEORDERS.VIEW.ORDERLINESTOGGLEBUTTON')}
			</Button>
			<Button className="btn btn--sml" togglable={true} selected={!showOrderLines} onClick={() => toggle(false)}>
				{t('MARKETPLACEORDERS.VIEW.FULFILLMENTORDERSTOGGLEBUTTON')}
			</Button>
		</ButtonGroup>
	);
};

const MarketplaceOrderListTemplate = ({
	t,
	viewStore,
	viewStore: {
		loading,
		listStore,
		tableData,
		baasicTableSettingsViewStore,
		queryUtility,
		expandChange,
		showOrderLines,
		toggle,
		columnFilterSetup,
		isExpand,
		removeFiltersModal: { removeFiltersConfirm },
		findOrder,
		change,
		showTodayShipments,
		onCheck,
		orderDateRangeViewStore,
	},
}) => {
	if (loading) return <Loader />;
	return (
		<section className="layout__main__body">
			<BaasicHeader
				title={'MAINMENU.ADMINISTRATION.MARKETPLACEORDERS'}
				baasicTableSettingsViewStore={baasicTableSettingsViewStore}
				reloadFunc={findOrder}
			>
				<div className="flex--primary align--h--right">
					<div className="spc--right--sml">
						<ButtonGroupContainer {...{ t, showOrderLines, toggle }} />
					</div>
					<div className="layout__main__subheader__item">
						<div className="flex--primary">
							<div>
								{!showTodayShipments && <OrderDateRangeFilter orderDateRangeViewStore={orderDateRangeViewStore} />}
							</div>
							<div>
								<BaasicCheckbox
									id={'showTodayShipments'}
									onChangeCallback={onCheck}
									label="MARKETPLACEORDERS.VIEW.SHOWTODAYSHIPMENTS"
									checked={showTodayShipments}
									className="input--check input--check--negative"
								/>
							</div>
						</div>
					</div>
					<BaasicTableExport tableViewStore={viewStore} fileTitle={fileNames.marketplaceOrder} />
				</div>
			</BaasicHeader>
			<div className="k-grid--expandable fullheight">
				<BaasicTable
					{...{
						tableData,
						queryUtility,
						viewStore,
						isExpand,
						detailComponent: showOrderLines ? OrderLinesExpandList : FulfillmentOrdersExpandList,
						expandChange,
						change,
					}}
					data={listStore.data.slice()}
					actions={viewStore}
				/>
			</div>
			<TableFilter viewStore={viewStore} columnFilterSetup={columnFilterSetup} />
			<BaasicConfirmModal modalParams={removeFiltersConfirm} />
			<ReactTooltip />
		</section>
	);
};
export default defaultTemplate(MarketplaceOrderListTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/MarketplaceOrderListTemplate.jsx